import { render, staticRenderFns } from "./PetStatistics.vue?vue&type=template&id=6918f726&scoped=true"
import script from "./PetStatistics.vue?vue&type=script&lang=js"
export * from "./PetStatistics.vue?vue&type=script&lang=js"
import style0 from "./PetStatistics.vue?vue&type=style&index=0&id=6918f726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918f726",
  null
  
)

export default component.exports